import type { CartMap, Product, RecommendationItem } from "../types";

export const getRecommendationPriceLabel = (item: RecommendationItem) => {
  if (!Number.isFinite(item?.price) || Number(item.price) <= 0) {
    return null;
  }
  return `${Number(item.price).toFixed(2)} zł${item.unit ? ` / ${item.unit}` : ""}`;
};

export const getRecommendationTextValues = (item: RecommendationItem) => {
  return {
    description: typeof item?.description === "string" ? item.description : "",
    availabilityLabel:
      typeof item?.availabilityLabel === "string" ? item.availabilityLabel : "",
  };
};

export const getRecommendationCartValues = ({
  product,
  cart = {},
  onQuantityChange,
}: {
  product: Product | null | undefined;
  cart?: CartMap;
  onQuantityChange?: (product: Product, value: number) => void;
}) => {
  return {
    quantity: product ? cart[product.id]?.quantity || 0 : 0,
    canEdit: Boolean(product && typeof onQuantityChange === "function"),
  };
};
